import {Injectable} from '@angular/core';
import {
  emptyVisionReport,
  IVisionReport,
  IVisionFiles,
  emptyVisionFiles,
  IVisionReportDetail,
  emptyVisionReportDetail,
  IVisionReportExport,
  emptyVisionReportExport
} from "@retail-data-factory/rdf-angular-types-api";
import {Observable, of, throwError} from "rxjs";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {Presenter} from "../../../internal/presenter/presenter";
import {map, catchError} from "rxjs/operators";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {DataService} from "../../../../services/external-api/data.service";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class ApiVisionService {

  /**
   * Получить список отчетов
   * @param dateFrom
   * @param dateTo

   getVisionReports(dateFrom: Date, dateTo: Date):Observable<Array<IVisionReport>> {
    return of([]);
  }
   */

  getVisionReports(dateFrom: string, merch: string, retailer: string) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/reports`;
    //const url = 'https://portal-dev.redfactory.io/restapi/v.1/vision/reports';
    const header = {
      'merch_id': merch,
      'retailer_id': retailer,
      'date_from': dateFrom
    };
    return this.dataService.getReportData(url, header).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(t => this.mapVisionDataToTable(t));
      }),
      catchError((error) => {
          const arr: Array<IVisionReport> = [];
          return throwError(arr);
        }
      ));
  }


  getVisionReportsExport(dateFrom: string, merch: string, retailer: string): Observable<Array<IVisionReportExport>> {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/reports/export`;
    const header = {
      'merch_id': merch,
      'retailer_id': retailer,
      'date_from': dateFrom
    };
    return this.dataService.getReportData(url, header).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(t => this.mapVisionDataExportToTable(t));
      }),
      catchError((error) => {
          const arr: Array<IVisionReportExport> = [];
          return throwError(arr);
        }
      ));
  }


  getVisionFileList(dateFrom: string, dateTo: string, merch: string, retailer: string, type: string) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/files`;
    const header = {
      'merch_id': merch,
      'retailer_id': retailer,
      'date_from': dateFrom,
      'date_until': dateTo,
      'type_code': type
    };
    return this.dataService.getReportData(url, header).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(t => this.mapVisionFileListToTable(t));
      })
    );
  }

  mapVisionDataToTable(item: object): IVisionReport {
    const obj: IVisionReport = {
      ...emptyVisionReport,
      id: item['site_code'],
      rpt: item['rpt'],
      site_code: item['site_code'],
      site_id: item['site_id'],
      rpt_date: item['rpt_date'] ? moment(item['rpt_date'], 'YYYYMMDD').format('DD.MM.YYYY') : '',
      m_noSKULT: item['m_noSKULT'] ? item['m_noSKULT'] : '',
      m_noSKULTyPhoto: item['m_noSKULT_YesPhoto'] ? item['m_noSKULT_YesPhoto'] : '',
      m_noLT_noReas_noPhoto: item['m_noLT_noReas_noPhoto'] ? item['m_noLT_noReas_noPhoto'] : '',
      m_noLT_YesPhoto: item['m_noLT_YesPhoto'] ? item['m_noLT_YesPhoto'] : '',
      d1: item['d1'],
      d2: item['d2'],
      d3: item['d3'],
      d4: item['d4'],
      err: item['err'],
      verify: item['verif'],
      bad_photos: item['bad_photos'],
      address: item['address'],
      reportId: item['report_id']
    };
    return obj;
  }

  mapVisionDataExportToTable(item: object): IVisionReportExport {
    const obj: IVisionReportExport = {
      ...emptyVisionReportExport,
      id: item['site_code'],
      rpt: item['rpt'],
      site_code: item['site_code'],
      site_id: item['site_id'],
      rpt_date: item['rpt_date'] ? moment(item['rpt_date'], 'YYYYMMDD').format('DD.MM.YYYY') : '',
      m_noSKULT: item['m_noSKULT'] ? item['m_noSKULT'] : '',
      m_noSKULTyPhoto: item['m_noSKULT_YesPhoto'] ? item['m_noSKULT_YesPhoto'] : '',
      m_noLT_noReas_noPhoto: item['m_noLT_noReas_noPhoto'] ? item['m_noLT_noReas_noPhoto'] : '',
      m_noLT_YesPhoto: item['m_noLT_YesPhoto'] ? item['m_noLT_YesPhoto'] : '',
      d1: item['d1'],
      d2: item['d2'],
      d3: item['d3'],
      d4: item['d4'],
      err: item['err'],
      verify: item['verif'],
      bad_photos: item['bad_PHOTOS'],
      address: item['address'],
      reportId: item['report_id'],

      idManufacture: item['id_manufacturer'],
      facing: item['facing'] ? item['facing'] : 0,
      reason: item['reason'] ? item['reason'] : '',
      reasonDetails: item['reason_details'] ? item['reason_details'] : '',
      fotoFrameCount: item['photo_frames_count'],

      isVeridied: item['is_veridied'] === 1,
      nbWeek: item['nb_week'],

      skuId: item['sku_id'] + '',
      skuName: item['sku_name'] ? item['sku_name'] : '',
      skuEan: item['sku_ean'] ? item['sku_ean'] : '',
      skuMerchId: item['sku_merch_id'] ? item['sku_merch_id'] : '',
      status: item['status'],

      photoWithBoxes: item['photo_with_boxes'],
      selected: item['selected'],

    };
    return obj;
  }

  mapVisionFileListToTable(item: object): IVisionFiles {
    const obj: IVisionFiles = {
      ...emptyVisionFiles,
      id: item['file_id'],
      date: item['date_last_update'] ? moment(item['date_last_update'], 'YYYYMMDD').format('DD.MM.YYYY') : moment().format('DD.MM.YYYY'),
      name: item['file_name'],
      type_name: item['type_name'],
      type_code: item['type_code'],
      merch_name: item['merch_name'],
      merch_code: item['merch_id'],
      retailer_name: item['retailer_name'],
      retailer_code: item['retailer_id'],
      last_rid: item['last_rid'],
      user_id_update: item['user_id_update']
    };
    return obj;
  }

  getNameFileUpdate(id): Observable<string> {
    const url = `${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/${id}`;
    return this.dataService.getReportData(url, {}).pipe(
      map((result: IServiceResponse) => {
        if (result) {
          return result.report[0]['FirstName'] + ' ' + result.report[0]['LastName'];
        }
      })
    );
  }

  /**
   * Получить отчет по ID
   * @param id
   */
  getVisionReport(id: string, param) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/reports/${id}`;
    const header = {
      'merch_id': param.merch,
      'retailer_id': param.retailer,
      'date_from': param.dateFrom
    };
    return this.dataService.getReportData(url, header).pipe(
      map((result: IServiceResponse) => {
        return this.mapVisionReportDetail(result.report[0]);
      }),
      catchError((error) => {
        return error;
      }));
  }

  mapVisionReportDetail(item: object): IVisionReportDetail {
    const obj: IVisionReportDetail = {
      ...emptyVisionReportDetail,
      reportId: item['report_header']['report_id'],
      rpt: item['report_header']['rpt'],
      verif: (item['report_header']['verif'] !== 0) ? true : false,
      siteId: item['report_header']['site_id'],
      siteCode: item['report_header']['site_code'],
      week: item['report_header']['week'],
      rptDate: item['report_header']['rpt_date'] ? moment(item['report_header']['rpt_date'], 'YYYYMMDD').toDate() : null,
      address: item['report_header']['address'],
      photoArr: this.mapPhotoArr(item['report_header']['photos']),
      skuLength: item['report_details'].length,
      skuErrLength: this.mapErrSku(item['report_details']),
      skuArr: this.mapSkuArr(item['report_details'])
    };
    return obj;
  }

  mapPhotoArr(item) {
    const chek = item.every(t => !t['photo_id']);
    if (chek) return [];
    const arr = item.map(t => ({
      altPhotoUrl: '../../../../img/no-img.png',
      errorPhotoUrl: false,
      photoId: t['photo_id'],
      photoUid: t['photo_uid'],
      photoUrl: t['photo_uri'],
      photoUrlStorage: t['photo_uri_storage'],
      photoName: t['photo_name'],
	  photoDate: t['photo_date'],
      photoFileName: t['photo_file_name'],
      approvedMiniPhoto: false,
      photoFavorites: t['photo_favorites']
    }));
    return arr;
  }

  mapSkuArr(item) {
    const arr = item.map(t => ({
      skuId: t['sku_id'] + '',
      skuName: t['sku_name'],
      idManufacture: t['id_manufacturer'],
      skuMerchId: t['sku_merch_id'],
      skuEan: t['sku_ean'],
      facing: t['facing'] ? t['facing'] : 0,
      fotoFrameCount: t['photo_frames_count'],
      status: t['status'] ? t['status'] : '',
      d1: t['d1'],
      d2: t['d2'],
      d3: t['d3'],
      d4: t['d4'],
      err: t['err'],
      reason: t['reason'] ? t['reason'] : '',
      reasonDetails: t['reason_details'] ? t['reason_details'] : '',
      photoWithBoxes: t['photo_with_boxes'],
      selected: false,
      item: t
    }));
    return arr;
  }

  mapErrSku(item) {
    let i = 0;
    item.forEach(t => {
      if (t.err === 1) {
        i++;
      }
    });
    return i;
  }

  /**
   * Получить фото по ID SKU
   * @param id
   */
  getPhotoSku(id: string) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/items/${id}/images`;
    return this.dataService.getReportData(url, {}).pipe(
      map((result: IServiceResponse) => {
        return result.report[0]['image'];
      }),
      catchError((error) => {
        return error;
      }));
  }

  /**
   * дообучить или плохое фото
   * @param id
   */
  postVisionReportDetailTrainOrBad(reportId: string, skuId: string, photoId: string, status: string, param: string) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/reports/${reportId}/photos/${photoId}/${status}=${param}`;
    const code = {
      item_id: skuId
    };
    return this.dataService.postData(url, code, {}).pipe(
      map((result: IServiceResponse) => {
        return 'success';
      }),
      catchError((error) => {
        return 'error';
      }));
  }

  /**
   * Передать значение ChekBox
   * @param id
   */
  postVisionReportDetailCheckBox(id: string, check: string) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/reports/${id}/verify?is_verified=${check}`;
    return this.dataService.postData(url, {}, {}).pipe(
      map((result: IServiceResponse) => {
        return 'success';
      }),
      catchError((error) => {
        return 'error';
      }));
  }

  /**
   * Получить merch
   */

  getVisionMerch() {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/merches`;
    return this.dataService.getReportData(url, {}).pipe(
      map(result => {
        return result.report;
      })
    );
  }

  /**
   * Получить retailers
   */

  getVisionRetailers() {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/retailers`;
    return this.dataService.getReportData(url, {}).pipe(
      map(result => {
        return result.report;
      })
    );
  }

  getVisionFilesType() {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/files/types`;
    return this.dataService.getReportData(url, {}).pipe(
      map(result => {
        return result.report;
      })
    );
  }

  postProcessFile(id) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/files/${id}/processing`;

    return this.dataService.postData(url, {}, {}).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  postUploadFile(header, body) {
    const url = `${this.configurationManager.getApiUrl('apiVision')}/files`;

    return this.dataService.postData(url, header, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  constructor(private dataService: DataService,
              private configurationManager: ConfigurationManager,
              private presenter: Presenter) {
  }
}
